import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';
import customizationFields from '../../fields/customizationFields';

const { client } = require('@/common-utils/libraries/axios/axios');
const { default: CUSTOMIZATION } = require('../apiUrls');

/**
 * @param responseData response.data object
 * @param responseData.items array
 * @param responseData.totalResults number
 *
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};

    const mappedItems = items.map(item => {
        return {
            [customizationFields.UUID.key]: item[customizationFields.UUID.key],
            [customizationFields.IDENTIFIANT.key]: item[customizationFields.IDENTIFIANT.key],
            [customizationFields.COLOR.key]: item[customizationFields.COLOR.key],
            [customizationFields.LABEL.key]: item[customizationFields.LABEL.key],
            [customizationFields.LOGO.key]: item[customizationFields.LOGO.key],
            [customizationFields.LOCALE.key]: item[customizationFields.LOCALE.key],
            [customizationFields.CREATED_AT.key]: item[customizationFields.CREATED_AT.key],
            [customizationFields.UPDATED_AT.key]: item[customizationFields.UPDATED_AT.key],
            [customizationFields.POS_TERMINALS_NUMBERS.key]: item[customizationFields.POS_TERMINALS_NUMBERS.key],
            [customizationFields.MPF_OPTIONS.key]: item[customizationFields.MPF_OPTIONS.key].map(option => ({
                [customizationFields.MPF_OPTIONS.NAME.key]: option[customizationFields.MPF_OPTIONS.NAME.key],
                [customizationFields.MPF_OPTIONS.VALUE.key]: option[customizationFields.MPF_OPTIONS.VALUE.key]
            }))
        };
    });

    data.items = mappedItems;
    data.totalResults = totalResults;

    return data;
}

const queryGetCustomizations = ({ query, merchantAccountId }, enabled) => {
    return {
        queryKey: [CUSTOMIZATION.CUSTOMIZATIONS.queryKey, query, merchantAccountId],
        queryFn: async () => {
            const response = await client.get(buildUrl(replaceParameters(CUSTOMIZATION.CUSTOMIZATIONS.url, { contractAccessId: merchantAccountId }), query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetCustomizations;